import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod/mini';
import { PortalProjectsTab } from './-components/portal-projects-tab';

export const Route = createFileRoute('/ngos/portals/$portalId/projects')({
	validateSearch: z.object({
		q: z.catch(z.optional(z.string()), undefined),
		page: z.catch(z.optional(z.number()), undefined),
	}),
	component: PortalProjectsTab,
});
